"use strict";

exports.__esModule = true;
exports.rgbToHex = rgbToHex;
exports.hexToRgb = hexToRgb;

function componentToHex(c) {
  var hex = c.toString(16);
  return hex.length == 1 ? '0' + hex : hex;
}
/**
 * Parse color parameters to hex value.
 * @param r
 * @param g
 * @param b
 */


function rgbToHex(value) {
  return '#' + componentToHex(value.r) + componentToHex(value.g) + componentToHex(value.b);
}
/**
 * Parse hex value to colors parameters.
 * @param hex
 */


function hexToRgb(hex) {
  var data = parseInt(hex[0] != '#' ? hex : hex.substring(1), 16);
  return {
    r: data >> 16 & 255,
    g: data >> 8 & 255,
    b: data & 255
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9oZWxwZXJzL2NvbG9ycy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFFQSxTQUFTLGNBQVQsQ0FBd0IsQ0FBeEIsRUFBaUM7QUFDN0IsTUFBSSxHQUFHLEdBQUcsQ0FBQyxDQUFDLFFBQUYsQ0FBVyxFQUFYLENBQVY7QUFDQSxTQUFPLEdBQUcsQ0FBQyxNQUFKLElBQWMsQ0FBZCxHQUFrQixNQUFNLEdBQXhCLEdBQThCLEdBQXJDO0FBQ0g7QUFFRDs7Ozs7Ozs7QUFNTSxTQUFVLFFBQVYsQ0FBbUIsS0FBbkIsRUFBZ0M7QUFDbEMsU0FBTyxNQUFNLGNBQWMsQ0FBQyxLQUFLLENBQUMsQ0FBUCxDQUFwQixHQUFnQyxjQUFjLENBQUMsS0FBSyxDQUFDLENBQVAsQ0FBOUMsR0FBMEQsY0FBYyxDQUFDLEtBQUssQ0FBQyxDQUFQLENBQS9FO0FBQ0g7QUFFRDs7Ozs7O0FBSU0sU0FBVSxRQUFWLENBQW1CLEdBQW5CLEVBQThCO0FBQ2hDLE1BQUksSUFBSSxHQUFHLFFBQVEsQ0FBRSxHQUFHLENBQUMsQ0FBRCxDQUFILElBQVUsR0FBVixHQUFnQixHQUFoQixHQUFzQixHQUFHLENBQUMsU0FBSixDQUFlLENBQWYsQ0FBeEIsRUFBNEMsRUFBNUMsQ0FBbkI7QUFDQSxTQUFPO0FBQ0gsSUFBQSxDQUFDLEVBQUUsSUFBSSxJQUFJLEVBQVIsR0FBYSxHQURiO0FBRUgsSUFBQSxDQUFDLEVBQUUsSUFBSSxJQUFJLENBQVIsR0FBWSxHQUZaO0FBR0gsSUFBQSxDQUFDLEVBQUUsSUFBSSxHQUFHO0FBSFAsR0FBUDtBQUtIIiwic291cmNlUm9vdCI6IiJ9